package com.sweetlime.dungeonamigo

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.sweetlime.dungeonamigo.di.initKoin
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize

// TODO: Replace placeholder values with your Firebase project credentials.
@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    Firebase.initialize(
        options = FirebaseOptions(
            apiKey        = "AIzaSyCHBVjM192wHfv4vU4EbEiKfYIiTsjUvN8",
            authDomain    = "dungeon-amigo.firebaseapp.com",
            projectId     = "dungeon-amigo",
            storageBucket = "dungeon-amigo.firebasestorage.app",
            gcmSenderId   = "428999568607",
            applicationId = "1:428999568607:web:1611b9622b81e38634cd6a"
        )
    )
    initKoin()
    ComposeViewport {
        App()
    }
}
